module.exports = __webpack_public_path__ + "media/images/gallery/snr_tab_off-15d23201da289f81e33d6af442981a19.jpg";